var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shengsheng-page"},[_c('img',{staticClass:"jiu-img",attrs:{"src":"/static/images/shengsheng/jiu.png","alt":"酒背景"}}),_vm._v(" "),_c('div',{staticClass:"overlay"}),_vm._v(" "),_c('div',{staticClass:"rules-container"},[_c('div',{staticClass:"rules-content",domProps:{"innerHTML":_vm._s(_vm.activityRule)}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76520f36","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ShengSheng/Rule.vue
// module id = null
// module chunks = 